<template>
  <div class="w-full min-h-screen flex flex-col">
    <div class="screen-content flex flex-col mt-32 pb-64">
      <h1 class="text-6xl font-bold text-primary-normal tracking-tighter mb-8">🤷‍♂️</h1>
      <p class="text-gray-700 text-lg">Looks like the page you are looking for is missing.</p>
    </div>
  </div>
</template>
